import { Component } from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: '[gbc-icon-button]',
    templateUrl: './icon-button.component.html',
    styleUrls: ['./icon-button.component.scss'],
})
export class IconButtonComponent {
  constructor() {}
}
